// Full-document render of the expired-login-token view: PageSkeleton (the
// React document shell) wrapping toppers' ExpiredTokenBody (the site
// AccountShell layout).
import React from "react";

import { templates } from "@reactivated";

import { ExpiredTokenBody } from "../components/ExpiredTokenBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ExpiredTokenDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ExpiredTokenBody {...props} />
    </PageSkeleton>
);
